import { PcsWorbRailContentType } from "../../../helpers/CrepoContentTypes";
import { CosmosIconStory, CosmosIconVideo } from "@cosmos/web-react";

/*
 * This map is a preparation of mapping content types to mostly unique icons.
 * In case the mapping is done mostly in badges, a switch case would be more appropriate.
 */
const iconMap: Partial<{
  [Property in PcsWorbRailContentType]: React.JSX.Element;
}> = {
  Film: <CosmosIconVideo />,
  Story: <CosmosIconStory />,
};

export const ExperienceWorbIcon = ({
  type,
}: {
  type: PcsWorbRailContentType;
}) => {
  // This "null" is simply a placeholder in case there'll be a general fallback icon.
  return iconMap[type] ?? null;
};
